import * as React from 'react';
import { type HTMLAttributes, type ReactNode, forwardRef } from 'react';

import { use$ } from '@legendapp/state/react';
import { Breakpoints } from '@volkswagen-onehub/components-core';
import styled, { css } from 'styled-components';

import { containerStore, fullscreenStore } from '../../store';

interface Props {
	children: ReactNode;
}

const ViewWrapper = forwardRef<HTMLDivElement, Props & HTMLAttributes<HTMLDivElement>>(
	({ children, ...props }, ref) => {
		const isFullscreenMode = use$(fullscreenStore.isFullscreenMode);
		const combinedHeight = use$(containerStore.combinedHeight);
		const bottomPanelExpansion = use$(containerStore.bottomPanelExpansion);

		return (
			<ProductViewWrapper
				ref={ref}
				isFullscreenMode={isFullscreenMode}
				heightOffset={combinedHeight}
				expansionHeight={bottomPanelExpansion}
				{...props}
			>
				{children}
			</ProductViewWrapper>
		);
	}
);

ViewWrapper.displayName = 'View-Wrapper';

const ProductViewWrapper = styled.div<{
	isFullscreenMode: boolean;
	heightOffset: number;
	expansionHeight: number;
}>`
	// IMPORTANT! This prevents other parts of FA from overflowing things like NBAB
	z-index: 0;

	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 0;

	width: 100vw;
	width: 100dvw;
	margin-left: calc(50% - 50vw);
	margin-left: calc(50% - 50dvw);

	// Required to prevent overflow to lower components when zooming
	overflow: hidden;

	// Required for bottom-control-panel as it exists outside grid
	position: relative;

	// TODO: remove and see if Rachel doesn't notice
	// Hack for android simulators and unsupported browsers that do not support new viewport units
	height: ${({ isFullscreenMode, heightOffset, expansionHeight }) =>
		isFullscreenMode ? '100%' : `calc(100vh - ${heightOffset ?? 0}px + ${expansionHeight}px)`};
	height: ${({ isFullscreenMode, heightOffset, expansionHeight }) =>
		isFullscreenMode ? '100%' : `calc(100lvh - ${heightOffset ?? 0}px + ${expansionHeight}px)`};

	${({ isFullscreenMode }) =>
		!isFullscreenMode &&
		css`
			@media (max-width: ${Breakpoints.b960 - 1}px) {
				height: auto;
			}
		`}
`;

export default ViewWrapper;
